import React from 'react'
import PropTypes from 'prop-types'
import {Box} from '@chakra-ui/react3'
import PartnerRedirectBtn from './ctas/partner-redirect'
import AddToCartBtn from './ctas/add-to-cart'
import NotifyMeBtn from './ctas/notify-me'
import BabyListBtn from './ctas/baby-list'
import OpenConfiguratorBtn from './ctas/open-configurator'

const CockpitCtaSection = ({viewModel}) => {
    const {product} = viewModel
    const displayTemplate = product?.c_displayTemplate

    if (viewModel.partnerRedirect.isAvailable) {
        return (
            <PartnerRedirectBtn
                redirectProps={viewModel.partnerRedirect.redirectProps}
                width="100%"
            />
        )
    }

    if (!viewModel.ecommerceEnabled) {
        return null
    }

    if (displayTemplate === 'xpdp-configurator') {
        return (
            <Box
                display="flex"
                flexDirection={{base: 'column', s: 'row'}}
                gap={{base: 'spacing-12', s: 'spacing-8'}}
            >
                <OpenConfiguratorBtn
                    flex="1"
                    disabled={!product?.c_configuratorConfig}
                    onClick={viewModel.openConfigurator.onClick}
                />
                {/* on configurator PDP: functionally the same as Configurator CTA (Start Configurator (with selected color - separate ticket)) */}
                <AddToCartBtn
                    product={product}
                    isLoading={viewModel.isLoading}
                    onClick={viewModel.addToCart.onClick}
                    width={{base: '100%', s: 'auto'}}
                    flex="1"
                />
            </Box>
        )
    }

    return (
        <Box
            display="flex"
            flexDirection={{base: 'column', s: 'row'}}
            gap={{base: 'spacing-12', s: 'spacing-8'}}
        >
            {product.isOrderable ? (
                <AddToCartBtn
                    product={product}
                    isLoading={viewModel.isLoading}
                    onClick={viewModel.addToCart.onClick}
                    width={{base: '100%', s: 'auto'}}
                    flex="1"
                />
            ) : (
                <NotifyMeBtn
                    onClick={viewModel.notifyMe.onClick}
                    width={{base: '100%', s: 'auto'}}
                    flex="1"
                />
            )}
            {viewModel.babyList.enabled && (
                <BabyListBtn
                    product={product}
                    onClick={viewModel.babyList.onClick}
                    width={{base: '100%', s: 'auto'}}
                    flex="1"
                />
            )}
        </Box>
    )
}

CockpitCtaSection.propTypes = {
    viewModel: PropTypes.object
}

export default CockpitCtaSection
